import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { CustomerDetails, LookupLists, Customer, State } from '@pos-app/data';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomersPartialState } from '../../+state/customers.reducer';
import { CreateShipToCustomer, CheckDuplicateCustomer, SelectCountry } from '../../+state/customers.actions';
import { customersQuery } from '../../+state/customers.selectors';
import { hasUnsavedChanges, clearUnsavedChanges, MessageService } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgIf, AsyncPipe } from '@angular/common';
import { CustomersShipToFormComponent } from '../../components/customers-ship-to-form/customers-ship-to-form.component';
import { CustomersDuplicateComponent } from '../../components/customers-duplicate/customers-duplicate.component';

@Component({
    selector: 'app-customers-ship-to',
    templateUrl: './customers-ship-to.component.html',
    styleUrls: ['./customers-ship-to.component.scss'],
    imports: [CoreUiModule, NgIf, CustomersShipToFormComponent, CustomersDuplicateComponent, AsyncPipe]
})
export class CustomersShipToComponent implements OnInit, OnDestroy {
  public selectedCustomerDetails$: Observable<CustomerDetails>;
  public lookupLists$: Observable<LookupLists>;
  public customerShipToForm: UntypedFormGroup;
  public formValid = false;
  public formDirty = false;
  public formValue = null;
  public unSubscribe$ = new Subject<void>();
  public isCreatingCustomer$: Observable<boolean>;
  public duplicateCustomers$: Observable<Customer[]>;
  public checkingDuplicate = false;
  public newCustomerDetails: any;
  public isCreatingCustomer: boolean;
  public filteredStateList: State[];

  constructor(private router: Router, private store: Store<CustomersPartialState>, private messageService: MessageService) {}

  ngOnInit() {
    this.selectedCustomerDetails$ = this.store.select(customersQuery.getSelectedCustomer);
     this.isCreatingCustomer$ = this.store.select(customersQuery.getIsCreatingCustomer);
    this.lookupLists$ = this.store.select(customersQuery.getLookupLists);
    this.store
      .select(customersQuery.getFilteredStates)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((filteredStates) => {
        setTimeout(() => {
          this.filteredStateList = filteredStates;
        }, 0);
      });
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  formDirtyHandler(dirty) {
    this.formDirty = dirty;
    if (dirty) {
      this.store.dispatch(hasUnsavedChanges({ unsavedChanges: true }));
      this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: true }));
    }
  }

  checkDuplicate() {
    this.checkingDuplicate = true;
    this.newCustomerDetails = {
      fullName: this.formValue.name,
      firstName: '',
      lastName: '',
      phoneNumber: this.formValue.phone,
      address1: this.formValue.addressLine1,
      email: this.formValue.email,
    };
    this.store.dispatch(new CheckDuplicateCustomer(this.newCustomerDetails));
    this.store
      .select(customersQuery.getDuplicateCustomers)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((duplicateCustomers) => {
        if (duplicateCustomers && duplicateCustomers?.length > 0) {
          this.checkingDuplicate = true;
          this.duplicateCustomers$ = of(duplicateCustomers);
          setTimeout(() => {
            document.getElementById('bottom').scrollIntoView({ behavior: 'smooth' });
          }, 100);
        } else if (duplicateCustomers && duplicateCustomers?.length === 0) {
          this.checkingDuplicate = false;
          this.duplicateCustomers$ = of([]);
          this.store.dispatch(new CreateShipToCustomer(this.formValue));
        }
      });
  }

  customerChoosen(customer: Customer) {
    if (customer) {
      this.store.dispatch(clearUnsavedChanges({ unsavedChanges: false }));
      this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
      this.router.navigate(['/pos/customers/' + customer.customerNumber]);
    } else {
      this.store.dispatch(new CreateShipToCustomer(this.formValue));
    }
  }

  cancel() {
    // this.store.dispatch(new ClearData());
    this.router.navigate(['pos/customers/search']);
  }

  getFilteredStateList(countryCode) {
    this.store.dispatch(new SelectCountry(countryCode));
  }
}

